
const isPro = Object.is(process.env.NODE_ENV, 'production') //process.env.NODE_ENV用于区分是生产环境还是开发环境

module.exports = {
    baseUrl: isPro ? 'https://serv.nmzp.com' : '/api'
}


//////////////////
// WEBPACK FOOTER
// ./config/api.config.js
// module id = mrgY
// module chunks = 4